import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import { BreakPointMobile } from "../../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  header: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space8,
  },
  container: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space24,
    width: "-webkit-fill-available",
  },
  item: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing.space20,
  },
  qrInner: {
    background: theme.colors.TextDefault,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 83,
    height: 83,
    minWidth: 83,
    minHeight: 83,
    borderRadius: theme.radius.small,
    padding: theme.spacing.space6,
    boxSizing: "border-box",
    [BreakPointMobile]: {
      height: 60,
      minHeight: 60,
      width: 60,
      minWidth: 60,
    },
  },
  qrCode: {
    height: "100% !important",
    width: "100% !important",
  },
  link: {
    cursor: "pointer",
    textDecoration: "underline",
    color: `${theme.colors.Primary} !important`,
  },
  icon: {
    padding: theme.spacing.space16,
    "&.ios": {
      transform: "rotate(90deg)",
    },
  },
}));
